var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 13.5063C29.4667 12.8396 28.9334 12.0396 28.2668 12.0396L20.6667 10.973L17.2001 4.03963C17.0667 3.77296 16.9334 3.63963 16.6667 3.5063C16.0001 3.1063 15.2001 3.37296 14.8001 4.03963L11.4667 10.973L3.86675 12.0396C3.46675 12.0396 3.20008 12.173 3.06675 12.4396C2.53341 12.973 2.53341 13.773 3.06675 14.3063L8.53341 19.6396L7.20008 27.2396C7.20008 27.5063 7.20008 27.773 7.33342 28.0396C7.73341 28.7063 8.53341 28.973 9.20008 28.573L16.0001 24.973L22.8001 28.573C22.9334 28.7063 23.2001 28.7063 23.4667 28.7063C23.6001 28.7063 23.6001 28.7063 23.7334 28.7063C24.4001 28.573 24.9334 27.9063 24.8001 27.1063L23.4667 19.5063L28.9334 14.173C29.2001 14.0396 29.3334 13.773 29.3334 13.5063Z",
    fill: "#F29469"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIcon);
export default __webpack_public_path__ + "static/media/rating-icon.8c918d24109ec7639a415c95d7750cfe.svg";
export { ForwardRef as ReactComponent };